import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Fonts } from 'components/base-ui'
import MembershipTierImage from 'components/hato-heart/components/MembershipTierImage'
import { AppContext } from 'contexts/AppProvider'
import { displayPrice } from 'helpers'
import NoneMembershipHatoHeart from 'components/NoneMembershipHatoHeart'
import { useNavigateReferrerUrl } from 'routes'
import { MembershipProviderEnum } from 'graphQL/hatostore/generate/operations'
import { HATO_HEART_ROUTES } from 'pages/hato-heart/routes'

interface MembershipHatoHeartProps {
  brandLogo: string
  vendorName: string
  membership: any
}

const MembershipHatoHeart: FC<MembershipHatoHeartProps> = ({ membership, brandLogo, vendorName }) => {
  const { membershipProgramHH, brand } = useContext(AppContext)
  const { t } = useTranslation()
  const navigateReferrerUrl = useNavigateReferrerUrl()

  const membershipContent = (
    <Section style={{ paddingBottom: 20 }}>
      <Title style={{ margin: 0, marginBottom: 8 }}>{t('membershipAccount')}</Title>
      {membership ? (
        <>
          {membershipProgramHH && (
            <MembershipTierImage membershipTier={membership?.memberTier} membershipProgramHH={membershipProgramHH} />
          )}
          <DetailsWrapper>
            <DetailsBox>
              <Fonts.BaseTitleRegular>
                {`${membership?.firstName} ${membership?.lastName}`.trim()}
              </Fonts.BaseTitleRegular>
              <Fonts.BaseTitleBold>
                {brand?.label} {membership?.memberTier}
              </Fonts.BaseTitleBold>
            </DetailsBox>
            <DetailsBox>
              <Fonts.BaseTitleRegular>{t('membershipPoints')}</Fonts.BaseTitleRegular>
              <Fonts.BaseTitleBold>{displayPrice(membership?.totalPoints)}</Fonts.BaseTitleBold>
            </DetailsBox>
          </DetailsWrapper>
        </>
      ) : membershipProgramHH?.membershipProvider === MembershipProviderEnum.HatoHeart ? (
        <NoneMembershipHatoHeart
          brandLogo={brandLogo}
          vendorName={vendorName}
          onRegisterMemberpship={() => navigateReferrerUrl(HATO_HEART_ROUTES.HOME)}
          onConnectMembership={() => navigateReferrerUrl(HATO_HEART_ROUTES.HOME, '?subpage=link-membership-with-phone')}
        />
      ) : null}
    </Section>
  )

  return membershipProgramHH ? membershipContent : null
}

export default MembershipHatoHeart

const Title = styled(Fonts.H2)``

const Section = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
`

const DetailsWrapper = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.XL};
`

const DetailsBox = styled.div`
  flex: 1;
`
